import { Layers, Sparkles, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
const technicalFeatures = [{
  title: ".3DM Master Files",
  description: "Native Rhino files optimized for jewelry manufacturing. Our models feature clean surfacing and precise tolerances, ensuring seamless integration with your existing CAD/CAM workflow and bench jeweler requirements.",
  icon: Layers
}, {
  title: "Production-Ready .STL",
  description: "High-resolution mesh exports guaranteed to be manifold and error-free. These files are specifically prepared for high-detail 3D printing in wax or resin, maintaining every intricate detail of the design.",
  icon: Sparkles
}, {
  title: "High-Res .JPG Renders",
  description: "Photorealistic 4K renderings that capture the true essence of the final piece. Perfect for client approvals, marketing materials, or pre-selling designs before the physical casting process begins.",
  icon: ShieldCheck
}];
export default function TheScienceOfShine() {
  return <section data-section-id="240462" id="technical-deliverables" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <span className="text-secondary font-mono text-xs tracking-widest uppercase mb-4">
            Digital Craftsmanship
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tighter mb-6 text-primary">
            Technical Deliverables
          </h2>
          <p className="text-muted-foreground font-default text-sm md:text-base max-w-2xl leading-relaxed">
            Every project is delivered with clinical precision. We provide the industry-standard 
            file formats required for flawless 3D printing, casting, and high-end marketing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {technicalFeatures.map((feature, i) => <Card key={i} data-index={i} className="bg-card/40 border-border/50 backdrop-blur-md shadow-lg hover:bg-card/60 transition-all duration-500 rounded-md">
              <CardHeader className="pb-4">
                <div className="w-12 h-12 rounded-md bg-secondary/10 flex items-center justify-center mb-6">
                  <feature.icon className="w-6 h-6 text-secondary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl font-bold tracking-tight text-primary">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="font-default text-sm leading-loose text-muted-foreground">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}